import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Col, Table, Row, Divider } from 'antd';
import { useTranslation } from 'react-i18next';
import { ExcelIcon } from 'icons';
import { Link, Route, Routes } from 'react-router-dom';
import Filters from 'components/filters';
import { useCompanies } from '../useCompanies';

import ChangeStatusModal from './changeStatusModal';
import DeleteModal from 'components/deleteModalView';
import styles from './style.module.scss';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const CompaniesMainPage = () => {
  const { t } = useTranslation();
  const {
    columns,
    data,
    filters,
    loading,
    handleCloseFilter,
    handleChangeFilters,
    onChangeTableFilter,
    handleDownloadExcel,
    updateInProcess,
    onUpdate,
    onDelete,
    onUpdateStatus,
    user,
  } = useCompanies(true);
  const pages = useRecoilValue(getPage);

  return (
    <>
      <PageHeader title={t('INSEGNE').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              disabled={loading}
              width={'138px'}
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
            >
              {t('Export')}
            </Button>
          </Col>
          {pages?.ability?.can_create && (
            <Col>
              <Link to={'new'}>
                <Button width={'138px'} big icon={<PlusOutlined />}>
                  {t('NUOVO')}
                </Button>
              </Link>
            </Col>
          )}
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Filters
          onClose={handleCloseFilter}
          onChange={handleChangeFilters}
          filters={filters}
        />
        <Divider />
        <Table
          columns={columns}
          dataSource={data.companies}
          pagination={data.pagination}
          loading={loading}
          rowKey='id'
          onChange={onChangeTableFilter}
          scroll={{ x: 1500 }}
        // bordered
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal
              description={
                'Attenzione! I dati cancellati non potranno essere recuperati.'
              }
              onClickDelete={onDelete}
            />
          }
        />
        {user?.master_admin && (
          <Route
            path={':id/status'}
            element={
              <ChangeStatusModal
                onUpdate={onUpdateStatus}
                updateInProcess={updateInProcess}
              />
            }
          />
        )}
      </Routes>
    </>
  );
};

export default CompaniesMainPage;
